import React, { Fragment, Component } from "react";
import NavBar from "../../common/forms/NavbarCopy";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Loader } from "../../common/forms/Loading/Loader";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { subDirectory } from "../../../config.json";
import "../../../styles/BoatBookingCancellation.scss";
// import qrcode from "../../../images/boat/qrcode.png";
import {
  getbookingDetails,
  GetCancellationReasons,
} from "../../../services/BookingCancellationService";
import { getLocalStorageValues } from "../../../services/boat";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal, Divider } from "antd";
import {
  TextInput,
  DropDown,
  TimePicker,
  FileUploader,
  NumberInput,
  TextArea,
} from "../../forms/index";
import { SkBookingCancellationCard } from "../../common/skeleton/subcatCardSkeleton"
class BookingCancellation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      varient: "",
      message: "",
      BookingHistoryData: [],
      openNotification: false,
      Reasons: [],
      isCancellationLoading: true,
      isCancellationAvailable: false,
      // currentdate: moment(new Date()).format("DD/MM/YYYY"),
    };
  }

  componentDidMount = async () => {
    await this.BookingCancellation();
    await this.setState({ loading: false });

  };

  BookingCancellation = async () => {
    this.setState({ loading: true })

    let data = {
      UserId: await getLocalStorageValues("UserId"),
      // UserId:"5214"
    };

    const res = await getbookingDetails(data);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({ BookingHistoryData: res.data.Response, loading: false, isCancellationLoading: false, isCancellationAvailable: true });
      }
    } else {
      this.setState({ BookingHistoryData: [], loading: false, isCancellationLoading: false, isCancellationAvailable: false });
    }

  };


  SingleTicket = (data) => {
    console.log(data)
    this.props.history.push({
      pathname: `./singleBookingCancellation`,
      state: {
        BookingId: data.BookingId,
        BoatHouseId: data.BoatHouseId,
        BoatReferenceNo: data.BoatReferenceNo,
        BookingDate: data.BookingDate,
        BoatHouseName:data.BoatHouseName

      }
    })
  };
  frameLoadAllBookings = () => {
    const allBookings = this.state.BookingHistoryData;


    return allBookings.map((allBookings) => (
      <div className="hotel_web1 d-flex justify-content-center container my-4 mx-auto ">
        <Row className="px-3 w-100">

          <Col md={12}>
            <Row>
              <Col md={6} className="">
                <p class="webh-name1"> {allBookings.BoatHouseName}</p>
                <div className="receiptdisplay1">
                  <div className="receiptbid1"> Booking Id  </div>
                  <div>:</div>
                  <div className="receiptvalue1">{allBookings.BookingId} </div>

                </div>
                <div className="receiptdisplay1">
                  <div className="receiptbid1">  Booking Date </div>
                  <div className="">:</div>
                  <div className="receiptvalue1"> {allBookings.BookingDate?.split(" ")[0]} </div>

                </div>
                {/* <div className="receiptdisplay1">
                  <div className="receiptbid1"> Booking Pin </div>
                  <div className="">:</div>
                  <div className="receiptvalue1">  {allBookings.BookingPin} </div>

                </div> */}
                <div className="receiptdisplay1">
                  <div className="receiptbid1">   Boat Type </div>
                  <div className="">:</div>
                  <div className="receiptvalue1"> {allBookings.PremiumStatus}</div>

                </div>



              </Col>
              <Col md={6} className="table-res1">

                {/* <div className="hisdiv">
                  <label class="pricevalue1  fs-h1">Price :</label>
                  <label>
                    <span class="pricevalue1 fs-h1"> ₹  {allBookings.InitNetAmount}</span>
                  </label>
                </div> */}



                <Row>
                  <div className="px-3 py-4">
                    {
                      <div className="btndisplay1"> <Button className="btn btn-danger mt-5 mr-3 cancelticketbtn web-btns"
                        onClick={() => this.SingleTicket(allBookings)}>
                        Cancel Ticket
                      </Button>
                      </div>

                    }
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>


      </div>
    ));
  };
  render() {
    const { loading, openNotification, isCancellationLoading, isCancellationAvailable } = this.state;
    console.log(this.state, "state")
    return (
      <Fragment>
        {/* <Loader fullPage loading={loading} /> */}
        <AddNotification
          visible={openNotification}
          variant={this.state.variant}
          message={this.state.message}
          onClose={() => this.setState({ openNotification: false })}
        />
        <div class="webCheckIn1">
          <NavBar {...this.props} />
          <Container fluid className="webCheckIn-con1">
            <div className="cancelscroll">
            <Row className="pt-3 mb-3">
              <div
                className="d-flex justify-content-between mx-auto"
                style={{ width: "90%" }}
              >
                <div
                  className="d-flex align-items-center cancelhomecolor initialpage"
                  style={{ fontSize: "16px", color: "black" }}
                  onClick={() => {
                    this.props.history.push(`${subDirectory}/cancellationHistory`);
                  }}
                >
                  <BsArrowLeft className="mr-2" />
                  Cancellation History
                </div>
                <div className="webcheck-headertitle cancelhomecolor"
                style={{ marginRight: "15%" }}>
                <div className="">  Boat Cancellation </div>
                </div>
                {/* <div
                  className="cancelhomecolor initialpage"
                  style={{ fontSize: "16px",}}
                  onClick={() => {
                    this.props.history.push(`${subDirectory}/cancellationHistory`);
                  }}
                >Cancellation History
                  <BsArrowRight className="ml-2 mr-2" />

                </div> */}
                <div></div>
              </div>
              {/* </Col> */}
            </Row>

            {isCancellationLoading && <div className="hotel_web1 d-flex justify-content-center container my-4 mx-auto "> <SkBookingCancellationCard viewBox="0 0 650 400" /></div>}
            {!isCancellationLoading && isCancellationAvailable && <div>{this.frameLoadAllBookings()}</div>}
            {!isCancellationLoading && !isCancellationAvailable && <div className="cnd"><div className="cancelnodata">No data found </div></div>}
         </div>
          </Container>
        </div>
        <>

        </>
      </Fragment>
    );
  }
}
export default BookingCancellation;


